<template>
	<div class="page" v-loading="loadingPage">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<router-link to="/crm/customer/add">
				<el-button type="success" round size="small">
					<span class="el-icon-plus"></span>
					添加客户
				</el-button>
			</router-link>
		</div>
		<div class="page-main">
			<el-card class="box-card">
				<div slot="header" class="flex justify-between align-center">
					<div>
						<span class="el-icon-search"></span>
						<span class="text-bold margin-left-sm">信息检索</span>
					</div>
				</div>
				<el-form :inline="true" :model="formSearch" class="demo-form-inline" label-suffix=":">
					<el-form-item label="编号"><el-input v-model="formSearch.data.id" clearable placeholder="客户编号,精准查找"></el-input></el-form-item>
					<el-form-item label="名称"><el-input v-model="formSearch.data.name" clearable placeholder="客户名称,支持模糊查询"></el-input></el-form-item>
					<el-form-item label="类型">
						<el-select v-model="formSearch.data.type" clearable placeholder="类型" style="width: 120px;">
							<el-option label="公司" value="公司"></el-option>
							<el-option label="个体" value="个体"></el-option>
							<el-option label="其他" value="其他"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="业务">
						<span v-if="salesman.length > 0">
							<el-tag
								size="small"
								type="info"
								disable-transitions
								:closable="salesman.length > 0"
								@close="clearSalesman(index)"
								v-for="(item, index) in salesman"
								:key="item.id"
								class="margin-right-sm"
							>
								<span>{{ item.name }}({{ item.officeid }})</span>
							</el-tag>
							<el-tag size="small" effect="dark" @click="check_employee_show('multiple', 'salesman')"><i class="el-icon-plus"></i></el-tag>
						</span>
						<el-button size="medium" @click="check_employee_show('multiple', 'salesman')" v-else>
							全部
							<i class="el-icon-arrow-down"></i>
						</el-button>
					</el-form-item>
					<el-form-item label="客服">
						<span v-if="service.length > 0">
							<el-tag
								size="small"
								type="info"
								disable-transitions
								:closable="service.length > 0"
								@close="clearService(index)"
								v-for="(item, index) in service"
								:key="item.id"
								class="margin-right-sm"
							>
								<span>{{ item.name }}({{ item.officeid }})</span>
							</el-tag>
							<el-tag size="small" effect="dark" @click="check_employee_show('multiple', 'service')"><i class="el-icon-plus"></i></el-tag>
						</span>
						<el-button size="medium" @click="check_employee_show('multiple', 'service')" v-else>
							全部
							<i class="el-icon-arrow-down"></i>
						</el-button>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="formSearch.data.addtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="loadinfos">查询</el-button></el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card margin-top" :body-style="{ padding: '0px' }">
				<el-table :data="tableData" style="width: 100%" stripe v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
					<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
					<el-table-column prop="id" align="center" label="客户编号" width="180"></el-table-column>
					<el-table-column prop="name" align="left" label="客户名称">
						<template slot-scope="scope">
							<div class="text-blue text-bold">{{ scope.row.name }}</div>
							<div class="text-grey">{{ scope.row.credit_code }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="contacter" align="center" label="联系人" width="220">
						<template slot-scope="scope">
							<span v-if="scope.row.contacter">{{ scope.row.contacter.name }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="subject_type" align="center" label="类型" width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.subject_type == 1" class="cu-tag line-blue radius">公司</span>
							<span v-else-if="scope.row.subject_type == 2" class="cu-tag line-cyan radius">个体</span>
							<span v-else class="cu-tag line-gray radius">其他</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="业务" width="120">
						<template slot-scope="scope">
							<el-popover placement="top" trigger="click" @show="userCard_show(scope.row.salesman_id)" v-if="scope.row.salesman">
								<user-card :info="userCardInfo[scope.row.salesman_id]"></user-card>
								<span slot="reference" class="text-link">{{ scope.row.salesman.name }}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column align="center" label="客服" width="120">
						<template slot-scope="scope">
							<el-popover placement="top" trigger="click" @show="userCard_show(scope.row.service_id)" v-if="scope.row.service">
								<user-card :info="userCardInfo[scope.row.service_id]"></user-card>
								<span slot="reference" class="text-link">{{ scope.row.service.name }}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="addtime" align="center" label="创建时间" width="180"></el-table-column>
					<el-table-column align="center" label="操作" width="120">
						<template slot-scope="scope">
							<router-link :to="'/crm/customer/view/' + scope.row.id"><el-button size="small" type="primary">查看</el-button></router-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="padding-tb text-right">
					<el-pagination
						background
						@size-change="pageSizeChange"
						@current-change="pageChange"
						:current-page="formSearch.page"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="20"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-card>
		<check-employee
			:current="checkEmployeeCurrent"
			:show="checkEmployeeShow"
			:dKey="checkEmployeeKey"
			@close="checkEmployeeClose"
			@change="changeEmployee"
			:type="checkEmployeeType"
		></check-employee>
		</div>
	</div>
</template>

<script>
import userCard from '@/components/user-card.vue';
import checkEmployee from '@/components/check-employee.vue';

export default {
	components: { userCard, checkEmployee },
	data() {
		return {
			loadingPage: false,
			searchData: {
				deptAndEmpTreeList: []
			},
			checkEmployeeShow: false,
			checkEmployeeCurrent: [],
			checkEmployeeKey: null,
			checkEmployeeType: 'single',
			infos_state: [],
			formSearch: {
				page: 1,
				size: 20,
				data: {}
			},
			salesman: [],
			service: [],
			total: 0,
			loading: false,
			tableData: [],
			loadingUserCard: false,
			userCardInfo: []
		};
	},
	beforecreate: function() {},
	created: function() {
		this.loadinfos();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		check_employee_show(type, key) {
			if (type == 'multiple') {
				this.checkEmployeeCurrent = this[key];
			} else {
				this.checkEmployeeCurrent = [];
			}
			this.checkEmployeeShow = true;
			this.checkEmployeeKey = key;
			this.checkEmployeeType = type;
		},
		checkEmployeeClose() {
			this.checkEmployeeShow = false;
		},
		changeEmployee(e) {
			this[e.key] = e.data;
		},
		clearSalesman() {
			this.service.splice(index, 1);
		},
		clearService(index) {
			this.service.splice(index, 1);
		},
		userCard_show(id) {
			if (!this.userCardInfo[id]) {
				this.$http.post('/server/index.php?m=components/userCard&a=getInfo', { id: id }).then(
					res => {
						if (res.result == 'ok') {
							//Vue.set(this.userCardInfo,id,res.data);
							this.userCardInfo[id] = res.data;
							this.userCardInfo = Object.assign([], this.userCardInfo);
						} else {
						}
					},
					r => {
						console.log(r);
					}
				);
			}
		},
		loadinfos() {
			if(this.salesman.length>0){
				this.formSearch.data.salesman=[];
				for(let i=0;i<this.salesman.length;i++){
					this.formSearch.data.salesman.push(this.salesman[i].id);
				}
			}
			if(this.service.length>0){
				this.formSearch.data.service=[];
				for(let i=0;i<this.service.length;i++){
					this.formSearch.data.service.push(this.service[i].id);
				}
			}
			this.loading = true;
			this.$http.post('/server/index.php?m=crm/customer&a=list', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.tableData = res.data.infos;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.loadinfos();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.loadinfos();
		}
	}
};
</script>

<style></style>
